import { apolloClient } from "@/apollo";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    userToken: localStorage.getItem("user_token"),
    userId: localStorage.getItem("user_id"),

    clientToken: localStorage.getItem("client_token"),
    clientOrderId: localStorage.getItem("order_id"),
    clientMenuId: localStorage.getItem("menu_id"),
    clientTableId: localStorage.getItem("table_id")
  },
  getters: {
    isUserAuthenticated: state => {
      return Boolean(state.userToken && state.userId);
    },
    isClientAuthenticated: state => {
      return Boolean(
        state.clientToken &&
          state.clientOrderId &&
          state.clientMenuId &&
          state.clientTableId
      );
    },
    orderId: state => state.clientOrderId,
    menuId: state => state.clientMenuId,
    tableId: state => state.clientTableId
  },
  mutations: {
    authenticate: (state, { userToken, userId }) => {
      state.userToken = userToken;
      state.userId = userId;

      localStorage.setItem("user_token", userToken);
      localStorage.setItem("user_id", userId);
      const redirectTo = router.currentRoute.query.redirectTo as string;
      if (redirectTo) {
        router.push(decodeURI(redirectTo));
      } else {
        router.push("/dashboard");
      }
    },
    reintiateOrder: () => {
      localStorage.removeItem("client_token");
      localStorage.removeItem("order_id");
      localStorage.removeItem("menu_id");
      localStorage.removeItem("table_id");
    },
    logout: state => {
      localStorage.removeItem("user_token");
      localStorage.removeItem("user_id");
      state.userToken = null;
      state.userId = null;
      router.push("/").then(() => {
        apolloClient.resetStore();
      });
    },
    setOrderId: (state, payload) => {
      state.clientOrderId = payload;
    }
  },
  actions: {}
};
